export const AUTH_ROUTES = {
  SIGN_IN: '/signin',
  SIGN_UP: '/signup',
  DASHBOARD: '/dashboard',
  FORGOT_PASSWORD: '/forgot-password'
} as const;

export const AUTH_ERRORS = {
  INVALID_CREDENTIALS: 'Invalid email or password',
  EMAIL_NOT_CONFIRMED: 'Please verify your email address',
  NO_USER_DATA: 'No user data returned',
  PROFILE_FETCH_ERROR: 'Failed to fetch user profile',
  DEFAULT: 'An error occurred during sign in'
} as const;